import { CREDO_RAMPUP_FEATURE } from '../constants';
import useQueryCredoEligibility from './useQueryCredoEligibility';
const useCredoRampup = () => {
  const {
    isLoading,
    data,
    error
  } = useQueryCredoEligibility({
    ownProps: {
      feature: CREDO_RAMPUP_FEATURE
    }
  });
  return {
    isLoading,
    data,
    error
  };
};
export default useCredoRampup;